import { processSteps } from "@/mocks/melonData";
import { SectionHeading, SectionShell } from "./brand";

export default function ProcessSteps() {
  return (
    <SectionShell id="process" className="bg-background-100/60">
      <SectionHeading
        eyebrow="核验流程 · 五步把瓜看准"
        title="从一条传闻到一份评级，我们这样做"
        desc="标准透明、结论可溯。任何一个环节都接受围观与质疑，因为我们卖的是「判断的依据」，而不是「笃定的情绪」。"
      />

      <ol className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {processSteps.map((p, i) => (
          <li
            key={p.title}
            className="relative flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700 text-xl">
                <i className={p.icon} />
              </span>
              <span className="font-heading text-3xl text-background-300">
                0{i + 1}
              </span>
            </div>
            <h3 className="mt-4 text-base font-semibold text-foreground-950">
              {p.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              {p.desc}
            </p>
          </li>
        ))}
      </ol>
    </SectionShell>
  );
}